/**
  Author: Lokech Arora - lokesh.arora@enabledata.com
  Purpose: Business line model actions
  Date: May 2020
**/

import { action, thunk } from 'easy-peasy';
//import API from '../../utils/api';
import * as businessLineService from '../../services/businessLine';
var businessLineList = [];

const businessLineModel = {
  isBusinessLinesLoaded: false,
  setIsBusinessLinesLoaded: action((state, payload) => {
    state.isBusinessLinesLoaded = payload;
  }),
  
  businessLineList: [],
  setBusinessLineList: action((state, payload) => {
    state.businessLineList = payload;
  }),
  businessLineListLoader: false,
  setBusinessLineListLoader: action((state, payload) => {
    state.businessLineListLoader = payload;
  }),
  getBusinessLineList: thunk(async (actions, payload) => {
    return await businessLineService.getBusinessLineList(payload)
      .then(function (response) {
        actions.setBusinessLineListLoader(false);
        businessLineList = response.data.data.items
        actions.setBusinessLineList(businessLineList);
        actions.setIsBusinessLinesLoaded(true);
        return response;
      })
      .catch(function (error) {
        actions.setBusinessLineListLoader(false);
        actions.setBusinessLineList([]);
        actions.setIsBusinessLinesLoaded(true);
        return error;
      });
  }),
  businessLine: {},
  setBusinessLine: action((state, payload) => {
    state.businessLine = payload;
  }),
};

export default businessLineModel;
